module.exports = __webpack_public_path__ + "img/topup-white.32b0b55f.svg";